import { MapResponse } from '@/models/map'

const PADDING = 3

export function getMapPadding(data: MapResponse['result']): number {
  const customBgWidth = data.background?.width

  if (typeof customBgWidth === 'number') {
    // disable padding for custom maps
    return 0
  }

  return PADDING
}
